import {
	GOOGLE_ANALYTICS_HELPER,
	// FIREBASE_ANALYTICS_HELPER,
	// SEGMENT_ANALYTICS_HELPER,
	HELPER,
	CONSTANTS,
	LocalStorageService,
} from '../../utils'
import { store } from '../../store'

// const OBJECT= {
//   SHIFT_SCREEN: "shift_screen",
//   USER_ID: "user_id",
//   META: "meta_properties",
//   USER_PROPERTIES: "user_properties",
//   INIT_APP: "init_app",
//   NAVIGATE_APP: "navigate_app",
//   PRODUCT: "product",
//   CLICK: "click",
//   DETAIL: "detail",
//   PURCHASE_ITEM: {purchase: "purchase", addTransaction: "add_transaction"},
//   STEP_CHECKOUT: "checkout_step",
// }

function _initializeGA() {
	GOOGLE_ANALYTICS_HELPER.initializeGA('login')
	// FIREBASE_ANALYTICS_HELPER.createEvent("login")
}

function _initializebShop() {
	GOOGLE_ANALYTICS_HELPER.initializebShop()
}

function _screenShift(event, category) {
	GOOGLE_ANALYTICS_HELPER.appShift(event, category)
	// SEGMENT_ANALYTICS_HELPER._createEvent( OBJECT.SHIFT_SCREEN, { step: event, option: category });
}

function _setUserSessionByID() {
	// FIREBASE_ANALYTICS_HELPER._setUserSessionByID(device_token)
	// SEGMENT_ANALYTICS_HELPER._createEvent( OBJECT.USER_ID, { device_token: device_token});
}

function _setMetaProperties() {
	// let obj={
	//   currency_code,
	//   default_lang,
	//   theme_colour,
	// }
	// FIREBASE_ANALYTICS_HELPER._setUserProperties(obj)
	// SEGMENT_ANALYTICS_HELPER._createEvent( OBJECT.META, obj);
}

function _setUserProperties() {
	// const { name, loyalty_points } = store.getState().customer.customer;
	// let obj={
	//   name,
	//   loyalty_points
	// }
	// FIREBASE_ANALYTICS_HELPER._setUserProperties(obj)
	// SEGMENT_ANALYTICS_HELPER._createEvent( OBJECT.USER_PROPERTIES, obj);
}

function _triggerEvent(event, options = {}) {
	// eslint-disable-next-line no-unused-vars
	GOOGLE_ANALYTICS_HELPER.createEvent(event, (options = {}))
	// FIREBASE_ANALYTICS_HELPER.createEvent(event, options = {})
	// SEGMENT_ANALYTICS_HELPER._createEvent( event, options = {});
}

function _setPageView(route) {
	GOOGLE_ANALYTICS_HELPER.setPageView(route.view)
	// FIREBASE_ANALYTICS_HELPER.setPageView({
	//   path: !HELPER.isEmpty(route.path) ? route.path : route,
	//   component: !HELPER.isEmpty(route.component) ? route.component : route,
	//   pageTitle: !HELPER.isEmpty(route.view) ? route.view : route,
	// })
	// SEGMENT_ANALYTICS_HELPER.setPageView(route.view);
}

function _cartActions(product, quantity = 1, category, operation = CONSTANTS.ADD_QTY) {
	let state = store.getState()
	const { currency_code } = state.config.merchant
	let action = 'add_to_cart'
	if (operation === CONSTANTS.ADD_QTY) {
		action = 'add_to_cart'
	} else {
		action = 'remove_from_cart'
	}
	let item = { ...product, item_qty: quantity, currency_code }
	// let obj={
	//   currency: item.currency_code,
	//   value: item.selected_variant?.price,
	//   items: item,
	//   category: category,
	// }
	// FIREBASE_ANALYTICS_HELPER.actionOnCart(obj, action);
	// SEGMENT_ANALYTICS_HELPER._createEvent( action, obj);
	if (action === 'add_to_cart') {
		GOOGLE_ANALYTICS_HELPER.cartAdd(item, quantity)
	}
	if (action === 'remove_from_cart') {
		GOOGLE_ANALYTICS_HELPER.cartRemove(item, quantity)
	}
}

function _productImpressions(itemList) {
	GOOGLE_ANALYTICS_HELPER.productImpressions(itemList)
	// SEGMENT_ANALYTICS_HELPER.productImpressions(itemList)
}

function _productClick(product, variant = null) {
	const state = store.getState()
	const { selected_category } = state.inventory
	let obj = {
		position: product?.key,
		name: product.name,
		id: product?.id,
		category: selected_category?.name,
		price: product.selected_variant?.discounted_price,
		// 'brand': productObj.brand,
		variant: HELPER.isNotEmpty(variant)
			? variant?.variant_name
			: product.selected_variant?.variant_name,
	}
	GOOGLE_ANALYTICS_HELPER.productClick(obj)
	// SEGMENT_ANALYTICS_HELPER._createEvent(OBJECT.PRODUCT,obj)
}

function _productDetail(product) {
	// let obj={
	//   name: product.name,
	//   id: product.id,
	//   price: product.selected_variant?.discounted_price,
	//   position: product.key
	// }
	GOOGLE_ANALYTICS_HELPER.productDetail(product)
	// SEGMENT_ANALYTICS_HELPER._createEvent(OBJECT.PRODUCT,obj)
}

function _productPurchase(cart_details) {
	const state = store.getState()
	const { catalogue_key } = state.config
	const { currency_code } = state.config.merchant
	// window.bSecure = window.bSecure || [];
	const cart_items = cart_details?.items
	const cartItems = cart_items.map((item) => {
		return {
			id: item?.product?.id,
			name: item?.product?.name,
			price: item?.product?.selected_variant?.discounted_price,
			quantity: item?.qty,
			category: item?.category,
			sku: item?.product?.selected_variant?.sku,
			// 'brand': 'Google',
			variant: item?.product?.selected_variant?.variant_name,
			// 'list': 'Search Results',
		}
	})
	let transactionId = LocalStorageService._getFromSessionStorage('transaction_id')
	if (HELPER.isEmpty(transactionId)) {
		transactionId = Math.random().toString(36).substring(2) + new Date().getTime().toString(36)
	}
	let purchase = {
		tax: 0,
		shipping: 0,
		affiliation: catalogue_key, //store or affiliation name
		revenue: cart_details?.sub_total_amount,
		value: cart_details?.sub_total_amount,
		currency: currency_code,
		transaction_id: transactionId,
		products: cartItems,
	}
	let addTransaction = {
		id: transactionId, // the same as for addItem to connect them
		affiliation: catalogue_key, //store or affiliation name
		revenue: cart_details?.summary?.total_amount, // obviously it's price * quantity
		shipping: cart_details?.summary?.shipment_charges,
		currencyCode: cart_details?.summary?.currency_code,
		products: cartItems,
	}
	GOOGLE_ANALYTICS_HELPER.productPurchase(purchase, addTransaction)
	// SEGMENT_ANALYTICS_HELPER.productPurchase(purchase, addTransaction,OBJECT.PURCHASE_ITEM)
}

const ANALYTICS_EVENT_CATEGORY = {
	NAVIGATION: 'General Navigation',
	SELLER_LIST: 'Seller List',
	CART: 'Cart',
	LOGIN: 'Login',
	PRODUCT_DETAIL: 'Product Detail',
	SHOP: 'Shop',
	ERROR: 'Error',
}

const ANALYTICS_EVENT_STEPS = {
	SHOP: 1,
	CART: 2,
	SELLER_LIST: 3,
	PRODUCT_DETAIL: 4,
}

const ANALYTICS_EVENT = {
	NAVIGATION: {
		LANG_CHANGE: {
			ACTION: 'Change language button',
			LABEL: 'Globe button',
		},
		PROFILE_DROPDOWN: {
			ACTION: 'Profile dropdown is clicked',
			LABEL: 'Profile button',
		},
		CART_MENU: {
			ACTION: 'Cart button is pressed',
			LABEL: 'Cart button',
		},
		POPUP: {
			TERMS: {
				ACTION: 'Terms Popup is pressed',
				LABEL: 'Terms Popup',
			},
			PRIVACY: {
				ACTION: 'Privacy Popup is pressed',
				LABEL: 'Privacy Popup',
			},
		},
		ABOUT_US: {
			ACTION: 'About us is pressed',
			LABEL: 'About us button',
		},
		PRODUCTS: {
			ACTION: 'View Products is pressed',
			LABEL: 'View Products button',
		},
		PRIVACY_POLICY: {
			ACTION: 'Privacy policy is pressed',
			LABEL: 'Privacy policy  button',
		},
	},
	PRODUCT_DETAIL: {
		OPEN: {
			ACTION: 'Product detail Open',
			LABEL: 'View product detail',
		},
		CLOSE: {
			ACTION: 'Product detail close',
			LABEL: 'View product detail',
		},
	},
	CATALOG: {
		BACK: {
			ACTION: 'Move to catalogue',
			LABEL: 'View catalogue',
		},
	},
}

const ANALYTICS_HELPER = {
	_setUserSessionByID,
	_setMetaProperties,
	_setUserProperties,
	_setPageView,
	_cartActions,
	_triggerEvent,
	_initializeGA,
	_initializebShop,
	_screenShift,

	_productImpressions,
	_productClick,
	_productDetail,
	_productPurchase,

	CATEGORY: ANALYTICS_EVENT_CATEGORY,
	EVENT: ANALYTICS_EVENT,
	EVENT_STEPS: ANALYTICS_EVENT_STEPS,
}
export default ANALYTICS_HELPER
